import { PaymentProvider, PaymentStatus } from '../../api/api-clients';

export enum AppPaymentStatus {
  Pending = 'Pending',
  Completed = 'Completed',
  Failed = 'Failed',
}

export enum AppPaymentProvider {
  Stripe = 'Stripe',
  Apple = 'Apple',
  Google = 'Google',
}

const STATUS_MAP: Record<PaymentStatus, AppPaymentStatus> = {
  [PaymentStatus._0]: AppPaymentStatus.Pending,
  [PaymentStatus._1]: AppPaymentStatus.Completed,
  [PaymentStatus._2]: AppPaymentStatus.Failed,
};

const PROVIDER_MAP: Record<PaymentProvider, AppPaymentProvider> = {
  [PaymentProvider._1]: AppPaymentProvider.Stripe,
  [PaymentProvider._2]: AppPaymentProvider.Apple,
  [PaymentProvider._3]: AppPaymentProvider.Google,
};

export interface AppPayment {
  id: string;
  status: AppPaymentStatus;
  provider: AppPaymentProvider;
  createdAt: Date;
  completedAt?: Date;
  verifiedUntil?: Date;
}

export function toAppPayment(raw: {
  id?: string;
  status?: PaymentStatus;
  provider?: PaymentProvider;
  createdAt?: Date;
  completedAt?: Date;
  verifiedUntil?: Date;
}): AppPayment {
  return {
    id: raw.id!,
    status: raw.status != null ? STATUS_MAP[raw.status] : AppPaymentStatus.Pending,
    provider: raw.provider != null ? PROVIDER_MAP[raw.provider] : AppPaymentProvider.Stripe,
    createdAt: raw.createdAt!,
    completedAt: raw.completedAt,
    verifiedUntil: raw.verifiedUntil,
  };
}
